import request from '@/utils/httpRequest'
import { data } from 'jquery'

export function noteInfo(id) {
    return request({
        url: '/app/business/dailyrecord/info/' + id,
        method: 'get'
    })
}

export function noteList(data) {
    return request({
        url: '/app/business/dailyrecord/list',
        method: 'get',
        params: data
    })
}

export function saveNote(data) {
    return request({
        url: '/app/business/dailyrecord/save',
        method: 'post',
        data
    })
}

export function updateNote(data) {
    return request({
        url: '/app/business/dailyrecord/update',
        method: 'post',
        data
    })
}
